import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTrending5"><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 3V15.3456L9.42188 10.4237L12 13.0018L17.1562 7.84559L20.2794 10.9688L19.2188 12.0294L17.1562 9.96691L12 15.1232L9.42188 12.545L4.5 17.4669V19.5H21V21H3V3H4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrending5;
